import { render, staticRenderFns } from "./ChangelogList.vue?vue&type=template&id=5aed2292"
import script from "./ChangelogList.vue?vue&type=script&lang=js"
export * from "./ChangelogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5aed2292')) {
      api.createRecord('5aed2292', component.options)
    } else {
      api.reload('5aed2292', component.options)
    }
    module.hot.accept("./ChangelogList.vue?vue&type=template&id=5aed2292", function () {
      api.rerender('5aed2292', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/ChangelogList.vue"
export default component.exports